module.exports = __webpack_public_path__ + "img/Frame_20.98ed17b0.png";